export const createStyles = (theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: '100%',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    boxSizing: 'border-box',
    width: { xs: '100%', md: 320, lg: 360 },
    maxWidth: '100%',
    minWidth: 0,
    pt: { xs: 1.5, sm: 2 },
    pb: { xs: 2, sm: 3 },
    gap: 0,
    minHeight: 0,
    overflow: 'hidden',
    borderRight: {
      xs: 'none',
      md: `1px solid ${theme.palette.divider}`,
    },
    borderBottom: {
      xs: `1px solid ${theme.palette.divider}`,
      md: 'none',
    },
    backgroundColor: {
      xs: theme.palette.background.default,
      md: theme.palette.background.paper,
    },
  },
  sidebarHeader: {
    flexShrink: 0,
    px: '16px',
  },
  backButton: {
    alignSelf: 'flex-start',
    minWidth: 'fit-content',
    mb: { xs: 1.5, sm: 2 },
    ml: -2,
    pl: 2,
    pr: 1.5,
    py: 1,
    gap: 1,
    border: 0,
    borderRadius: 0.5,
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    fontSize: '1rem',
    fontWeight: 500,
    '& .MuiButton-startIcon': {
      margin: 0,
    },
    '&:hover': {
      border: 0,
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: 1.5,
    mb: '12px',
  },
  titleIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 40,
    height: 40,
    minWidth: 40,
    minHeight: 40,
    '& img': {
      display: 'block',
      width: 40,
      height: 40,
    },
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontStyle: 'normal',
    fontSize: '1.25rem',
    lineHeight: '160%',
    letterSpacing: '0px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.text.primary,
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: { xs: '100%', md: 'auto' },
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  feedLayout: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    minHeight: 0,
    px: { xs: 2, md: 3, xl: '188px' },
    pt: { xs: 2, md: 5 },
    pb: { xs: 2, md: 3 },
    gap: 2,
    overflow: 'hidden',
  },
  composerRegion: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: { xs: '100%', md: 800 },
    mx: { md: 'auto' },
    minWidth: 0,
  },
  feedControlsRegion: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: { xs: '100%', md: 800 },
    mx: { md: 'auto' },
    minWidth: 0,
    minHeight: 48,
    pb: 2,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  feedFilter: {
    ml: 'auto',
  },
  scheduledHeader: {
    flexShrink: 0,
    width: '100%',
    minWidth: 0,
    color: theme.palette.text.primary,
  },
  postsRegion: {
    flex: 1,
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: { xs: '100%', md: 800 },
    mx: { md: 'auto' },
    minWidth: 0,
    minHeight: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  postsList: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    gap: { xs: 2, sm: 2.5, md: 3 },
  },
  postPlaceholderCard: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    px: { xs: 2, sm: 3 },
    py: { xs: 2, sm: 3 },
    gap: 2,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
    backgroundColor: theme.palette.background.paper,
  },
  placeholderHeader: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    gap: 1.5,
  },
  placeholderIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 36,
    height: 36,
    borderRadius: '50%',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover,
  },
  placeholderText: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minWidth: 0,
  },
  placeholderFooter: {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    pt: 1.5,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  createPostButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    width: '2rem',
    height: '2rem',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
});
